export default {
    THEME: {
        COLOURS: {
            SUCCESS: 'success',
            WARNING: 'warn',
            ERROR: 'error',
            INFO: 'info'
        }
    }
};